import { render } from "./UsersAdd.vue?vue&type=template&id=cd597248&scoped=true"
import script from "./UsersAdd.vue?vue&type=script&lang=js"
export * from "./UsersAdd.vue?vue&type=script&lang=js"

import "./UsersAdd.vue?vue&type=style&index=0&id=cd597248&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd597248"]])

export default __exports__